/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as mapActions from "store/actions/mapActions";
import { Form } from "components";

function Opacity({ item, active, setActive }) {
  // reducer
  const dispatch = useDispatch();
  const step = 1;
  const min = 0;
  const max = 100;
  const [opacitySliderValue, setOpacitySliderValue] = useState(
    item.opacity || 0
  );

  const handleOpacityChange = (newValue) => {
    dispatch(mapActions.handleOpacityLayer({ value: newValue, item }));

    item.opacity = newValue;
    setOpacitySliderValue(newValue);
  };

  return (
    <div
      className={`tcf-map--opacity-filter${
        active ? " tcf-map--opacity-filter--width" : ""
      }`}
    >
      <span
        className={`tcf-map--opacity-filter-btn${
          active ? " tcf-map--opacity-filter-btn--active" : ""
        }`}
        onClick={() => setActive(!active)}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M7.76904 0.894934C7.98046 0.925121 8.19768 0.771531 8.22648 0.538453C8.2545 0.313742 8.09509 0.108664 7.87 0.0810195C7.5848 0.0457734 7.294 0 7 0C3.15558 0 0 3.1552 0 7C0 10.8448 3.15558 14 7 14C7.294 14 7.5848 13.9542 7.86997 13.919C8.09506 13.8913 8.25448 13.6863 8.22645 13.4615C8.19842 13.2368 7.98853 13.0742 7.76902 13.1051C7.65163 13.1196 7.5297 13.1193 7.41013 13.1271V0.87284C7.52973 0.880687 7.65163 0.880359 7.76904 0.894934ZM13.9126 6.07794C13.8821 5.85285 13.6731 5.69581 13.4519 5.72545C13.2269 5.75509 13.069 5.96137 13.0987 6.18609C13.1347 6.45285 13.1523 6.72684 13.1523 7C13.1523 7.26955 13.1347 7.53752 13.1003 7.79707C13.0679 8.04202 13.2582 8.2609 13.508 8.2609C13.7107 8.2609 13.8861 8.1107 13.9142 7.90442C13.9526 7.60963 14 7.30521 14 7C14 6.69077 13.9526 6.38077 13.9126 6.07794ZM9.32796 1.30348C9.82543 1.50694 10.2957 1.77652 10.7259 2.10416C10.9038 2.24052 11.1633 2.20724 11.3002 2.02645C11.438 1.8462 11.4028 1.58864 11.2225 1.45127C10.7366 1.08078 10.2042 0.775757 9.63878 0.544031C9.43209 0.459922 9.18936 0.558852 9.10366 0.768332C9.01797 0.977813 9.11807 1.21737 9.32796 1.30348ZM13.222 9.1321C13.0154 9.046 12.7734 9.14452 12.6861 9.354C12.4795 9.85218 12.208 10.3209 11.8786 10.7479C11.7408 10.9273 11.7745 11.1849 11.9539 11.3231C12.1328 11.4615 12.3909 11.4278 12.5291 11.2486C12.9019 10.764 13.2094 10.2326 13.4439 9.66801C13.5305 9.45894 13.4311 9.219 13.222 9.1321ZM10.7387 11.8866C10.3093 12.2155 9.83987 12.4858 9.34319 12.6901C9.13412 12.7762 9.03397 13.0162 9.12048 13.2257C9.20511 13.432 9.44199 13.5355 9.6556 13.4487C10.2188 13.2168 10.7507 12.9104 11.2369 12.5379C11.4172 12.4001 11.4508 12.1426 11.313 11.9627C11.1761 11.7829 10.9189 11.7493 10.7387 11.8866ZM12.6805 4.63239C12.7687 4.84373 13.0113 4.93921 13.2164 4.8527C13.4255 4.76539 13.5241 4.52506 13.4367 4.31596C13.2012 3.75208 12.8926 3.22162 12.5187 2.73823C12.3793 2.55798 12.1214 2.52593 11.9435 2.66454C11.7641 2.80312 11.7312 3.06067 11.8698 3.23971C12.1996 3.66662 12.4721 4.13481 12.6805 4.63239Z"
            fill="#AFA7A1"
          />
        </svg>
      </span>
      {active && (
        <Form.Range
          min={min}
          max={max}
          step={step}
          value={opacitySliderValue}
          onChange={handleOpacityChange}
        />
      )}
    </div>
  );
}

export default Opacity;
